import { GridContainer } from "#/ui/Layout"
import {
  OverviewBorrowBanner,
  OverviewBridgedAssets,
  OverviewLatestTransactions,
  OverviewRewards,
  OverviewUnbridgedAssets,
  OverviewUserAssets,
  OverviewWelcomeMessage,
} from "#/ui/Overview"

export default function OverviewPage() {
  return (
    <GridContainer maxWidth="730px" width="100%">
      <OverviewWelcomeMessage />
      <OverviewUserAssets />
      <OverviewBorrowBanner />
      <OverviewBridgedAssets />
      <OverviewUnbridgedAssets />
      <OverviewLatestTransactions />
      <OverviewRewards />
    </GridContainer>
  )
}
